import React from 'react';
import { TagIcon, XIcon } from './icons';

interface PendingChipProps {
  label: string;
  onRemove: () => void;
}

const PendingChip: React.FC<PendingChipProps> = ({ label, onRemove }) => (
  <div className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-[#E8EEF0] rounded-[8px] text-[#223746] text-sm leading-5 tracking-[0.25px]">
    <TagIcon className="shrink-0 text-[#2A4455]" />
    <span>{label}</span>
    <button
      type="button"
      aria-label={`Usuń oczekujący tag ${label}`}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onRemove();
      }}
      className="ml-0.5 flex items-center justify-center rounded-full hover:bg-[#C5D3DC] focus:outline-none focus-visible:ring-1 focus-visible:ring-[#2A4455] transition-colors cursor-pointer"
    >
      <XIcon className="text-[#2A4455]" />
    </button>
  </div>
);

export default PendingChip;
